import React from "react";

/**
 * Privacy Policy Content
 * Source: BRT Systems Pte Ltd Privacy Policy
 */
export const PrivacyPolicyContent: React.FC = () => (
    <>
        <p>
            BRT Systems Pte Ltd strongly believe in Data Protection regulations
            and ensuring compliance, most importantly, to exercise corporate
            responsibility of protecting our customers/partners confidentiality
            with the highest possible level of protection within the capability
            of the organization. This Privacy Policy is meant to highlight to all
            our customers what data we collect, why we collect it, and what we do with it.
            We hope you will read it carefully so that you can trust us with
            your information when you engage with BRT Systems Pte Ltd on any products
            and its services. BRT Systems Pte Ltd is not responsible for the privacy
            or security practices of our Distributors & Resellers, which may differ
            from those set forth in this privacy policy. Please check with individual
            Distributors & Resellers about the policies they have in place.
        </p>
        <h1>1 Privacy Policy</h1>
        <p>
            As our valued customer, when you engage with BRT Systems Pte Ltd, we
            want you to be clear how we use the information you share so that
            you are clear on how we are committed to protecting your data.
        </p>

        <h2>1.1 Our Privacy Policy explains</h2>
        <ul>
            <li>What information we collect and why we collect it.</li>
            <li>
                How we use and process this information; and the choices we
                offer, including how to access and update information.
            </li>
        </ul>
        <p>
            Your privacy matters to us – always. If you have any question please
            contact us at{" "}
            <a href="mailto:support@brtsys.com">support@brtsys.com</a>. What
            information is needed and why we collate this information. We
            collect information that is sufficient to drive and complete order
            fulfilment and deliver our product and services. We collect
            information in the following ways:
        </p>

        <ul>
            <li>
                <strong>Information you give us voluntarily.</strong>
            </li>
        </ul>
        <p>
            When you make any purchase, enquiry, feedback or register an account
            for product warranty and to use our products and services etc., we
            will require your personal information such as your name, email
            address, ship-to address and telephone number; namely for
            salutation, non-marketing and marketing communication, verification
            and executing the delivery of goods and services.
        </p>

        <ul>
            <li>
                <strong>
                    Information we get from your use of our products and
                    services.
                </strong>
            </li>
        </ul>
        <p>
            When you use our products and services or when interacting with our
            sites, we may collate and process network and system information,
            configuration, usage data, images, or any other information from our
            products or third-party devices which are connected to our platform
            so as to optimize and support individual preferences and deliver our
            solutions. For products and services that are entirely installed
            on-premises, all system and user data are stored, generated, and
            processed within the organization that implements these products. It
            is at the discretion of the organization to use any information that
            is collected or generated by the product. BRT Systems Pte Ltd does
            not, in any way store, monitor, collect or process any information
            other than the information which was given by the organization or
            users for the purpose such as for purchasing, installation, enquiry,
            warranty registration, troubleshooting or marketing communications.
            For products and services that are cloud connected, BRT Systems Pte
            Ltd stores and processes user personal data for the purpose such as
            for providing service, purchasing, installation, enquiry, warranty
            registration and troubleshooting or marketing communications.
            Further, BRT Systems Pte Ltd stores and monitors product generated
            data to provide monitoring, alerting and eventful services
            subscribed by the user. Such product generated data are always under
            the control of the user for offloading and deletion from our
            servers. BRT Systems Pte Ltd constantly participate in exhibitions
            and seminars worldwide, to showcase our latest initiatives and
            update our development progress. During such events, we may collect
            information from enquiries or through survey forms that are
            distributed to visitors. The objective is to follow-up on potential
            customers or to support our existing partners. Additionally, may it
            be new or existing customers who have any questions or feedback
            regarding technical applications or concerns, communication may be
            established with BRT Systems Pte Ltd. When you contact BRT Systems
            Pte Ltd, we keep a record of your communication to help solve any
            issues you might be facing. We may use your email address for any
            marketing communication such as to inform you about our services,
            product updates or improvements. BRT Systems Pte Ltd will only
            collect these given information so as to close the loop with the
            sole intention of providing our solution or sharing of the latest
            information about the organization. We will ask for your consent
            before using information for purposes other than those that are set
            out in this contract.
        </p>

        <h2>1.2 How we use the information we collect</h2>
        <p>
            We use the information we collect to execute transactions and to
            deliver our services requested by you. Kindly note that BRT Systems
            Pte Ltd.&apos;s internal or third-party cloud server data may be
            stored on servers located outside of the country you live. This set
            of information only serves the purpose for references,
            personalization, verification, and product enablement, and for our
            internal marketing teams to understand consumers&apos; needs, usage
            trends and for planning product road maps. We process your personal
            data to send you important information regarding the Services,
            changes to our terms, conditions, and policies and/or other
            administrative information as well to provide marketing and
            promotional materials to you on our Products and Services. We will
            only update this information upon formal indication by our customer
            so as to remain contactable and the above stated reasons. We
            generally retain personal data for so long as it may be relevant to
            the purposes identified herein. BRT Systems Pte Ltd does not
            practice any form of personal data monitoring other than for the
            purpose of sharing individual&apos;s own stored information, for
            enhancement of product application and usage. BRT Systems Pte Ltd
            may use third-party services such as, but not limited to, cloud
            service providers to store and retrieve customer data or payment
            processors for processing payments on behalf of BRT Systems Pte Ltd.
            Such third-party service providers shall have compatible data
            privacy policy as BRT Systems Pte Ltd.
        </p>

        <h2>1.3 Information we share</h2>
        <p>
            We do not share personal information with companies, organizations,
            and individuals outside of BRT Systems Pte Ltd and there is no
            external processing of your information provided to us, unless one
            of the following circumstances applies:
        </p>
        <ul>
            <li>
                Sharing of personal information to third party who perform
                certain business-related functions for us such as providing
                installation, configuration, payment, and training and support
                services.
            </li>
            <li>
                To our customers and other business partners who provide you,
                directly or indirectly, with third party devices, and/or
                networks and systems through which you access and use our
                products and Services.
            </li>
            <li>
                To an affiliate or other third party in the event of any
                reorganization, merger, sale, joint venture, assignment,
                transfer or other disposition of all or any portion of our
                business, assets, or stock (including without limitation in
                connection with any bankruptcy or similar proceedings). In such
                an event, you will be notified via email and/or a prominent
                notice on our website of any change in ownership, incompatible
                new uses of your personal information, and choices you may have
                regarding your personal information.
            </li>
            <li>
                For legal reasons. We will only share this information with
                authorities if we have a good-faith belief that the disclosure
                of the information is absolutely necessary to:
                <ul>
                    <li>
                        Comply with official legal procedure or mandatory
                        enforceable governmental request.
                    </li>
                    <li>
                        Investigation of potential fraudulent, abusive, unlawful
                        activities or violations of Terms of Service.
                    </li>
                    <li>
                        Establishing our legal rights or defending against legal
                        claims.
                    </li>
                    <li>
                        Address or otherwise prevention of security or technical
                        issues.
                    </li>
                </ul>
            </li>
        </ul>

        <h2>1.4 Our Transparency and Your Rights</h2>
        <p>
            We respect our customers&apos; privacy concerns. Our goal is to be
            clear about what information is needed and only register those that
            we need for our purpose. We believe you should have means to control
            your information. You can exercise your control prior to your
            engagement with BRT Systems Pte Ltd or, even after doing so via our
            corporate website. You can always manage your preferences and
            control your personal information by writing to our corporate
            e-mail. Our Customer Support Team will be glad to assist in your
            privacy requests. No fee is usually required to access your personal
            information. Services we provide to support your privacy rights are
            as follows:
        </p>
        <ul>
            <li>The right to be informed and to have your consent.</li>
            <li>The right of access, rectification, erasure.</li>
            <li>The right of portability.</li>
            <li>The right to object, omit and escalate.</li>
        </ul>
        <p>
            BRT Systems Pte Ltd will respect the choices you make to limit or
            control your personal information that you have shared via the use
            of our product and services. If that information is incorrect, we
            strive to give you ways to update it quickly or to delete it –
            unless we have to keep that information for legitimate business or
            legal purposes. We also make provisions for you to control your
            experience with us, so that you can manage your marketing
            preferences or opt out of our newsletter circulations. We provide
            the assurance of a response to any complete request via our website{" "}
            <a
                href="https://www.brtsys.com"
                target="_blank"
                rel="noopener noreferrer"
            >
                https://www.brtsys.com
            </a>.
        </p>

        <h2>1.5 Information Security</h2>
        <p>
            BRT Systems Pte Ltd will always strive towards protecting our
            user&apos;s information, from unauthorized access, alteration,
            disclosure, or destruction. We restrict access to personal
            information to BRT Systems Pte Ltd employees, and only limited to
            those who need to know that information for executing our services.
            All our employees including customer fronting staff are subjected to
            strict contractual confidentiality obligations and may be
            disciplined or terminated if they fail to meet these obligations.
        </p>

        <h2>1.6 Compliance, Changes and Cooperation</h2>
        <p>
            We are committed to adhere to our Privacy Policy. In addition, BRT
            Systems Pte Ltd will align to continuous improvement by monitoring
            regulatory enhancements and adopt appropriate guidelines. Although
            our Privacy Policy may change from time to time, we want to assure
            you that your rights mentioned in our Privacy Policy herein, will
            not reduce without notification and consent. You may access our
            privacy policy on our website and all changes will be reflected at
            the said website. Should there be any significant change, we will
            issue an official notice on our website and via email notification
            of our privacy policy changes. Such notices will still govern your
            use of our products and services, and you are responsible for
            reading and understanding them. You are bound by any changes to the
            Privacy Policy when you use the Services after such changes have
            been posted. Use of information we collect now is subject to the
            Privacy Policy in effect at the time such information is used. When
            we receive formal written complaints, we will reach out to the
            person who has expressed concern, to understand the perspective and
            to resolve the issue. BRT Systems Pte Ltd will work according to the
            regulatory authority&apos;s guidelines, report to data protection
            authorities, to update and resolve any complaints regarding personal
            data rights that we cannot resolve with our users directly.
        </p>

        <h2>1.7 Child Privacy Protection</h2>
        <p>
            We do not knowingly collect, store, use or share information that
            could reasonably be used to identify children under the age of 13.
            To be consistent with the applicable children privacy protection
            regulation, BRT Systems Pte Ltd will highlight to users of our
            services with an acknowledgement that the user is above 13 years of
            age. If you are a parent or guardian of a child under the age of 13
            and believe he or she has disclosed personal information to us
            without your consent, please contact us at{" "}
            <a href="mailto:support@brtsys.com">support@brtsys.com</a>. If we
            learn that we are engaged in activities with such users, we will
            halt such processing and will take reasonable measures to promptly
            remove applicable information from our records.
        </p>
    </>
);

/**
 * Terms of Service Content
 * Source: BRT Systems Pte Ltd Terms of Service
 */
export const TermsOfServiceContent: React.FC = () => (
    <>
        <h1>Terms of Service (ToS)</h1>
        <p>
            These Terms of Service (this &quot;Agreement&quot;) create a binding
            agreement between you as an individual or the business entity or
            organization indicated in the Customer Order which you validly
            represent (&quot;YOU,&quot; &quot;YOUR,&quot; &quot;YOURSELF&quot; or
            &quot;CUSTOMER&quot;) and BRT SYSTEMS PTE LTD (BRTSYS). This
            Agreement governs the CUSTOMER download, access, and use of the
            BRTSYS IoTPortal™, a cloud based remote sensor monitoring and
            control solution, which includes which includes BRTSYS IoTPortal
            Gateway, IoTPortal Cloud and IoTPortal Client, data collected from
            edge-devices (&quot;Service Data&quot;), and any related software,
            services and documentation as may be made available through our
            website, or through our mobile application (collectively known as
            &quot;Services&quot;). By clicking the &quot;Accept&quot; button
            and/or downloading or using any portion of the SERVICES, the
            CUSTOMER (I) agrees to be bound by this Agreement; and (II) present
            and warrant that (a) the terms of this Agreement have been carefully
            read and understood; (b) the CUSTOMER is 18 years of age or older or
            other legal age to enter into a binding agreement; and (c) the
            CUSTOMER have the authority to enter into this Agreement and bind
            the corporation, organization, or any legal entity the CUSTOMER is
            representing. If the CUSTOMER does not have such authority, and or
            does not accept the terms of this Agreement, the CUSTOMER must not
            download, install, nor use the Services. In addition to the terms of
            this Agreement, all information that BRTSYS collect, receive, and
            process in connection with the CUSTOMER&apos;s use of the Services
            is governed by our Privacy Policy. The CUSTOMER consent to all
            actions BRYSYS take with respect to your information consistent with
            our Privacy Policy.
        </p>

        <h2>1 The Services</h2>

        <h3>1.1 Service</h3>
        <p>
            We grant to you a worldwide, non-exclusive, royalty-free, revocable
            licence to: (a) View this website/mobile app and the material on
            this website on a computer or mobile app on a mobile device. (b)
            Copy and store this website and the material on this website in your
            web browser cache memory; (c) Print pages from this website for your
            own [personal and non-commercial] use. We do not grant you any other
            rights in relation to this website/mobile app or the material on
            this website. In other words, all other rights are reserved. For the
            avoidance of doubt, you must not adapt, edit, change, transform,
            publish, republish, distribute, redistribute, broadcast, rebroadcast,
            or show or play in public this website/mobile app or the materials
            in this website/mobile app (in any form or media) without our prior
            written permission.
        </p>

        <h3>1.2 Access Right</h3>
        <p>
            Subject to the terms of this Agreement and CUSTOMER strict
            compliance thereof, BRTSYS grants the CUSTOMER a limited,
            non-exclusive, non-sublicensable, non-transferable, revocable
            license during the Term to (a) access and use the Services as made
            available by BRTSYS, download, install, and solely for use in
            conjunction with, or interface with, BRTSYS products and accessories
            on a computing device owned or otherwise controlled by the CUSTOMER
            (e.g. a desktop, laptop, or tablet device; and (b) access, stream,
            download and/or use on such computing device the documentation
            (including user manuals, technical manuals and any other materials
            (&quot;Documentation&quot;) provided by BRTSYS from time to time) as
            well as any content made available or otherwise accessible through
            BRTSYS website or mobile application.
        </p>

        <h3>1.3 No Competitive Access</h3>
        <p>
            The CUSTOMER may not access the Services if they are a direct
            competitor of BRTSYS, except with BRTSYS&apos;s express prior
            written consent. The CUSTOMER may not access the Services for
            competitive purposes.
        </p>

        <h3>1.4 Content &amp; Conduct</h3>
        <p>
            The CUSTOMER shall not (a) use (including make any copies of ) the
            Services or Documentation beyond the scope of the license granted
            under &quot;Access Right&quot; section above; (b) modify, translate,
            adapt or otherwise create derivative works or improvements, whether
            or not patentable, of the Services; (c) reverse engineer, dissemble,
            decompile, decode or otherwise attempt to derive or gain access to
            the source code of the Services or any part thereof; (d) remove,
            delete, alter or obscure any title, trademarks, service marks, trade
            names, legends, watermarks or any copyright, patents or other
            intellectual property or proprietary rights notices from the
            Services, including any copy thereof; (e) remove, disable,
            circumvent or otherwise create or implement any workaround to any
            copy protection, rights management or security features in or
            protecting the Services. The CUSTOMER shall not engage in activities
            when using the Services that (i) violate the law, regulations, rule,
            court verdicts, resolutions or administrative measures that are
            legally binding; (ii) infringe any intellectual property rights of
            BRTSYS and/or a third party; (iii) lead to the misrepresentation of
            BRTSYS and/or a third party, or intentionally spread false
            information; (iv) other activities that may be deemed by BRTSYS to
            be inappropriate. Any violation of the above limitations or
            restricted activities shall be deemed a material breach of this
            Agreement for which BRTSYS, in its sole discretion, may terminate
            this Agreement and your access to the Services.
        </p>

        <h3>1.5 Networks and Communications</h3>
        <p>
            The CUSTOMER shall be solely responsible for procuring and
            maintaining its network connections and telecommunications links
            from its systems to the Services, including, but not limited to, web
            browser that supports protocols used by IoTPortal™, including the
            Transport Layer Security (TLS) protocol or other protocols accepted
            by IoTPortal™; and for all problems, conditions, delays, delivery
            failures, and all other loss or damage arising from or relating to
            the Customer&apos;s network connections or telecommunications links
            or caused by the internet. BRTSYS is not responsible for notifying
            the CUSTOMER of any upgrades, fixes, or enhancements to any such
            software or for any compromise of data, including service data,
            transmitted across computer networks or telecommunications
            facilities (including but not limited to the internet) which are not
            owned, operated, or controlled by BRTSYS. BRTSYS assume no
            responsibility for the reliability or performance of any connections
            as described in this section.
        </p>

        <h3>1.6 Right to Restrict Functionalities</h3>
        <p>
            BRTSYS reserves the right to restrict functionalities or suspend the
            Services (or any part thereof), the CUSTOMER account or the
            CUSTOMER&apos;s and/or end-users&apos; rights to access and use the
            Services and remove, disable or quarantine any service data if (a)
            BRTSYS reasonably believe that the CUSTOMER or end-users have
            violated this agreement; or (b) BRTSYS suspect or detect any
            malicious software connected to the CUSTOMER account or use of a
            service by the CUSTOMER or end-users, or (c) Any unpaid subscription
            charges. This right includes the removal or disablement of service
            data. Unless legally prohibited from doing so, BRTSYS will use
            commercially reasonable efforts to contact the CUSTOMER directly via
            email to notify them when taking any of the foregoing actions.
            BRTSYS shall not be liable to the CUSTOMER, end-users or any other
            third party for any such modification, suspension, or discontinuation
            of their rights to access and use the Services. Any suspected
            fraudulent, abusive, or illegal activity by the CUSTOMER or
            end-users may be referred to law enforcement authorities at
            BRTSYS&apos;s sole discretion.
        </p>

        <h2>2 Access to the Services</h2>

        <h3>2.1 Account Registration</h3>
        <p>
            To use the Services, the CUSTOMER must register and create an
            account (the &quot;Account&quot;) by providing vital registration
            details (name, valid contact number, e-mail address) or other
            information deemed crucial. It is a condition of the CUSTOMER
            Account creation, access, and use of the Services that all the
            information provided is correct, current, and complete.
        </p>

        <h3>2.2 Administrator Control &amp; Responsibility</h3>
        <p>
            The CUSTOMER is responsible for the internal management and
            administration of the platform and Service Data within the Account.
            In addition, the CUSTOMER is responsible for (i) Maintaining the
            confidentiality of the passwords of the Account; and (ii)
            Designating those individuals who are authorized to access the
            Account; the CUSTOMER must notify BRTSYS immediately of any breach
            of security or unauthorized use of an Account.
        </p>

        <h3>2.3 Subscriptions, Renewals &amp; Terminations</h3>
        <p>
            The Services is available under monthly subscription plan,
            chargeable in US Dollar (USD). The Agreement for purchasing a paid
            subscription plan becomes binding upon clicking &quot;Pay&quot; for
            a paid plan. Each paid subscription will automatically renew unless
            the CUSTOMER cancels the subscription before the current term
            expires. The full amount of each renewal term will be charged on the
            first day of the renewal. In consideration for the Services, the
            CUSTOMER shall timely pay that certain subscription fee in the
            amount and subject to the payment schedule. The CUSTOMER account
            will become unusable and access to the Services will be terminated
            upon cancellation of subscription plan. BRTSYS is under no further
            obligations to CUSTOMER upon the termination of subscription. BRTSYS
            reserves the right to refuse or block any cancel free trial accounts
            or paid subscriptions at any time for any reason.
        </p>

        <h3>2.4 Data Storage</h3>
        <p>
            The CUSTOMER receives 5GB of storage data per subscription and is
            solely responsible in managing the data to avoid data disruption
            should the storage exceeds the storage limit. The CUSTOMER may set a
            reminder email when storage consumption reached a predetermined
            level and/or by offloading or deleting data.
        </p>

        <h3>2.5 Token Entitlements &amp; Consumption</h3>
        <p>
            Services within the IoTPortal™ is chargeable and/or payable via
            Token. A certain unit of Allocated Tokens will be provided to each
            Account at the beginning of the monthly billing cycle. Any unused
            Allocated Tokens from the previous monthly billing cycle are reset
            to zero. Bonus Tokens are received through promotional activities.
            Any addition of Bonus Tokens causes the expiry date of the old and
            new Bonus Tokens to be adjusted to the earlier date of the two.
            Purchased Tokens are added to the subscription through purchases.
            Purchased Tokens expire one month after subscription is cancelled.
        </p>

        <h3>2.6 Modifications</h3>
        <p>
            The CUSTOMER acknowledges that BRTSYS reserves the right to (i)
            upgrade, modify, replace, or reconfigure the Services at any time;
            (ii) change the fee schedule, support terms, and service level
            agreements for the Services, subject to that the CUSTOMER will be
            provided with a commercially reasonable advance notice of any
            deprecation of any material feature or functionality.
        </p>

        <h2>3 Payment Processing</h2>

        <h3>3.1 Payment Information</h3>
        <p>
            To purchase a subscription, the CUSTOMER is required to (a) provide
            valid credit or payment card information, contact number, billing
            address and related information; and (b) promptly update any changes
            any changes that may occur, with Braintree by PayPal™(&quot;Payment
            Agent&quot;). By submitting such information, the CUSTOMER grant
            BRTSYS the right to provide such information to the Payment Agent
            for the purposes of facilitating the subscription and/or for any
            charges related to IoTPortal™ service or other payment instrument in
            advance on a periodic basis in accordance with the terms of the
            service plan for the Services, and for periodic subscription charges
            applicable to Services to which the CUSTOMER subscribe until their
            subscription to the Services terminates, and the CUSTOMER further
            agrees to pay any subscription charges so incurred. The CUSTOMER
            acknowledges and agrees that BRTSYS is not responsible for how the
            Payment Agent credit card or other payment method processor
            transmits, stores, uses and shares the information.
        </p>

        <h3>3.2 Taxes</h3>
        <p>
            Unless otherwise stated, BRTSYS charges include Goods and Service
            Tax (&quot;GST&quot;) gazette by the Republic of Singapore at the
            time of billing. For billing country located outside Singapore, the
            CUSTOMER will not be charged GST. BRTSYS will invoice the CUSTOMER
            for such taxes if BRTSYS believe they have a legal obligation to do
            so, and the CUSTOMER agrees to pay such taxes if so invoiced.
        </p>

        <h3>3.3 Payment Portals</h3>
        <p>
            If the CUSTOMER mandates BRTSYS to use a vendor payment portal or
            compliance portal which charges BRTSYS a subscription fee or a
            percentage of any uploaded invoice as a required cost of doing
            business, the CUSTOMER shall be invoiced by BRTSYS for, and they are
            obligated to pay, the cost of this fee.
        </p>

        <h2>4 Ownership &amp; Security of Service Data</h2>

        <h3>4.1 Ownership</h3>
        <p>
            All data provided by CUSTOMER pertaining to its business, personnel,
            clients, or accounts processed by or stored in BRTSYS&apos; systems
            shall be kept (please refer to BRTSYS Privacy Policy), shall be used
            only to carry out this Agreement, may not be disclosed to anyone
            except employees, agents, processors, and contractors of BRTSYS for
            the purposes of administration and performance of the Services. All
            such data shall be and remain the property of CUSTOMER and will only
            be used by BRTSYS to perform its obligations under this Agreement.
        </p>

        <h3>4.2 No Sale of Service Data</h3>
        <p>
            BRTSYS will never sell, rent, or lease the CUSTOMER&apos;s service
            data to any third party. BRTSYS will not share the CUSTOMER&apos;s
            service data with third parties, except as permitted by this
            agreement and to provide, secure and support the Services.
        </p>

        <h3>4.3 Safeguards</h3>
        <p>
            BRTSYS will maintain reasonable administrative, physical, and
            technical safeguards, in accordance with standard industry practice,
            for protection of the security, confidentiality and integrity of
            subscriber data. Those safeguards will include, but will not be
            limited to, measures for preventing access, use, modification, or
            disclosure of subscriber data by personnel except (i) To provide the
            Services and prevent or address service, support, or technical
            problems; (ii) As compelled by law; or (iii) As the CUSTOMER
            expressly permit in writing.
        </p>

        <h3>4.4 Sub-Processors</h3>
        <p>
            The CUSTOMER acknowledges and agrees that BRTSYS may use
            sub-processors, who may access Service Data, to provide, secure and
            improve the Services.
        </p>

        <h2>5 Terms, Cancellation &amp; Termination</h2>

        <h3>5.1 Terms</h3>
        <p>
            Unless the CUSTOMER&apos;s account and subscription to a service is
            terminated in accordance with the terms of this agreement or unless
            otherwise provided for in an subscription form (a) The CUSTOMER
            subscription to a service will renew for a subscription term
            equivalent in length to the then expiring subscription term and (b)
            The subscription charges applicable to the CUSTOMER&apos;s
            subsequent subscription term shall be BRTSYS&apos;s standard
            subscription charges for the applicable service plan at the time
            such subsequent subscription term commences.
        </p>

        <h3>5.2 Payment Upon Termination</h3>
        <p>
            Except for the CUSTOMER termination under section 5.3, if they
            terminate their subscription to a service or cancel their account
            prior to the end of their then effective subscription term, or if
            BRTSYS terminate or cancel the CUSTOMER account pursuant to section
            5.3, in addition to any other amounts the CUSTOMER may owe BRTSYS,
            they must immediately pay any then unpaid subscription charges
            associated with the remainder of such subscription term.
        </p>

        <h3>5.3 No Refunds</h3>
        <p>
            If the CUSTOMER elects to terminate their subscription to the
            service or cancel their account prior to the end of their then
            current subscription term, no refunds or tokens for subscription
            charges or other fees or payments will be provided to the CUSTOMER
            including prepaid tokens. No part of unused subscription entitlement
            or prepaid tokens will be eligible for refund.
        </p>

        <h3>5.4 Export of Service Data</h3>
        <p>
            For thirty (30) days after the effective date of termination or
            expiration of this agreement, upon CUSTOMER&apos;s request, BRTSYS
            will make service data available to the CUSTOMER for export or
            download as provided in the documentation. Thereafter, BRTSYS will
            have no obligation to maintain or provide any service data, and as
            provided in the documentation, BRTSYS will, unless prohibited by law
            or legal order, delete the customer service data within IoTPortal™
            Services.
        </p>

        <h2>6 Intellectual Property (IP) Rights</h2>
        <p>
            The CUSTOMER acknowledges the rights granted to the CUSTOMER to use
            the Services under this agreement do not convey any additional
            rights in the Services, Documentation (including any copies thereof)
            and/or in any IP rights of BRTSYS associated therewith. All rights,
            title, and interest in and to the Services and all hardware,
            software, and other components of or used to provide the services,
            including all related IP rights, Copyrights and Trademark will
            remain with BRTSYS and belong exclusively to BRTSYS.
        </p>

        <h2>7 Warranties &amp; Disclaimers</h2>

        <h3>7.1 Warranties</h3>
        <p>
            BRTSYS warrant that during an applicable subscription term (a) This
            agreement and the documentation will accurately describe the
            applicable administrative, physical, and technical safeguards for
            protection of the security, confidentiality, and integrity of
            service data; and (b) The Services will perform materially in
            accordance with the applicable documentation. For any breach of a
            warranty in this section, the CUSTOMER&apos;s exclusive remedies are
            those described in Clause 9 herein.
        </p>

        <h3>7.2 Disclaimers</h3>
        <p>
            Except as specifically set forth in Clause 7.1, the sites and the
            Services, including all server and network components, are provided
            on an &quot;as is&quot; and &quot;as available&quot; basis, without
            any warranties of any kind to the fullest extent permitted by law,
            and BRTSYS expressly disclaim any and all warranties, whether
            express or implied, including, but not limited to, any implied
            warranties of merchantability, title, fitness for a particular
            purpose, and non-infringement. The CUSTOMER acknowledges that BRTSYS
            do not warrant that the Services will be uninterrupted, timely,
            secure, error-free, or free from viruses or other malicious
            software, and no information or advice obtained by the CUSTOMER from
            BRTSYS or through the Services shall create any warranty not
            expressly stated in this agreement.
        </p>

        <h2>8 Indemnification by Customer</h2>
        <p>
            Subject to this Agreement, the CUSTOMER will (I) defend, or at its
            option settle, any Claim made or brought against BRTSYS by a third
            party that (i) The CUSTOMER Data, the CUSTOMER&apos;s or a third
            party&apos;s technology, software, materials, data or business
            processes; (ii) a combination of the Subscription Services with
            non-BRTSYS products or services; (iii) The CUSTOMER&apos;s use of
            the Subscription Services, other than as authorized in this
            Agreement, violates applicable law or regulations or infringes the
            intellectual property rights of, or has otherwise harmed, a third
            party; and (II) pay (a) any final judgement or award directly
            resulting from such Claim, or (b) or those dames agreed to in a
            monetary settlement of such Claim.
        </p>

        <h2>9 Limitation of Liability</h2>
        <p>
            BRTSYS shall not be liable to the CUSTOMER, whether in contract or
            in tort or under any other legal theory (including, without
            limitation, strict liability, and negligence) for lost profits or
            revenues, loss, or interruption of use, lost or damaged data,
            reports, documentation or security, or similar economic loss, or for
            any indirect, special, incidental, consequential, or similar
            damages, arising out of or in connection with the performance or
            non-performance of this Agreement, or for any claim made against the
            CUSTOMER by any other party, even if BRTSYS has been advised of the
            possibility of such claim. In any case, BRTSYS&apos; cumulative
            liability under any and all claims made by the CUSTOMER shall not
            exceed the amount the CUSTOMER paid to BRTSYS relating to the
            affected Services. Notwithstanding anything to the contrary, no
            action, regardless of form, arising out of or in connection with
            this Agreement may be brought by the CUSTOMER more than one (1) year
            after the first to occur of (i) the termination or expiration of
            this agreement or (ii) the event giving rise to such cause of
            action.
        </p>

        <h2>10 Third Party Service Providers</h2>
        <p>
            The CUSTOMER agrees that BRTSYS, and the third-party service
            providers that are utilized by BRTSYS to assist in providing the
            Services to the CUSTOMER, shall have the right to access the
            CUSTOMER&apos;s account and to use, modify, reproduce, distribute,
            display, and disclose the personal data to the extent necessary to
            provide, secure or improve the Services. Any third-party service
            providers utilized by BRTSYS will only be given access to the
            CUSTOMER&apos;s account as is reasonably necessary to provide the
            Services and will be subject to (a) Confidentiality obligations
            which are commercially reasonable and substantially consistent with
            the standards described in the privacy policy; and (b) Their
            agreement to comply with the data transfer restrictions applicable
            to personal data as set forth in section 6.
        </p>

        <h2>11 Severability</h2>
        <p>
            If any provision in this agreement is held by a court of competent
            jurisdiction to be unenforceable, such provision shall be modified
            by the court and interpreted to best accomplish the original
            provision to the fullest extent permitted by law, and the remaining
            provisions of this agreement shall remain in effect.
        </p>

        <h2>12 Governing Law</h2>
        <p>
            This agreement shall be governed by the laws of the Republic of
            Singapore, without reference to conflict of laws principles. Any
            disputes under this agreement shall be resolved by the international
            arbitration act, under the jurisdiction of Singapore. The CUSTOMER
            hereby expressly agrees to submit to the exclusive personal
            jurisdiction of this jurisdiction for the purpose of resolving any
            dispute relating to this agreement or access to or use of the
            Services.
        </p>

        <h2>13 Survival</h2>
        <p>
            This Agreement shall survive any termination with respect to use of
            the Services by the CUSTOMER. Termination of this Agreement shall
            not limit a party&apos;s liability for obligations accrued as of or
            prior to such termination or for any breach of this Agreement.
        </p>
    </>
);
